import React from 'react';
import Navigation from './Navigation';
import './Header.scss';
import { isMobile } from 'react-device-detect';

function Header() {
  return (
    <header className={`app-header ${isMobile ? "mobile" : "desktop"}`}>
      <Navigation />
    </header>
  );
}

export default Header;
